export const RECEIVE_WELCOME_MAT = "RECEIVE_WELCOME_MAT";
